
import { OnboardingService } from './onboarding.service';

export const ONBOARDING_SERVICES: any[] = [
    OnboardingService,
];
export * from './onboarding.service';
